import * as ActionImages from "./Action";

export default {
  ...ActionImages,
};
